// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.g14RrfVdvhA3cldPRa1d {
  width: 100%;
  height: 100%;
  background-color: white;
  padding: 16px;
  border-radius: 8px;
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  border-bottom: 1px solid #c4c4c4;
}

.zBIBTF1ZWUwZz3HhHfv7 {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  max-height: calc(100vh - 18rem);
}

.EpuI2pda4rp9qbbZkr4R, .ZABmhpxJkDP9ZPfLxe0v {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  column-gap: 32px;
}

.ZABmhpxJkDP9ZPfLxe0v {
  margin-bottom: 16px;
}

.iOltA2ddn_DELFU5ZoVg {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.FKzLf9UVlD3ttUq7UY04 {
  display: flex;
  flex-direction: row;
  column-gap: 4px;
  padding-bottom: 4px;
  font-family: "Chakra Petch";
  font-size: 18px;
  font-weight: bold;
  border-bottom: 1px solid #c4c4c4;
}

.ntssC0Dow3yHUWkDyvXg {
  color: #48CAE4;
}

.mnpcagNcBbt_uBntNR_1 {
  display: grid;
  grid-auto-columns: calc(25% - 32px) calc(25% - 32px) calc(25% - 32px) calc(25% - 32px);
  column-gap: 32px;
}

.TlWMoVaZDutf0u_bCNAQ {
  display: flex;
  flex-direction: row;
  flex: 2 1;
  column-gap: 32px;
}

.gzwRw_s3CtfURBNSZcIz {
  width: 182px;
}

.Swj3N4c8riS_42i4qb55 {
  min-height: 200px;
  width: 100%;
}

.qudWP3yZXRN8Cs5P3Lsv {
  display: flex;
  flex-direction: row;
  justify-content: end;
  font-family: "Chakra Petch";
  font-size: 14px;
  font-weight: bold;
  color: #D62828;
  padding-bottom: 16px;
}

.W87yG8HBDrMIcluIgJwq {
  display: flex;
  flex-direction: row;
  column-gap: 16px;
  justify-content: end;
}

.EVSZR28XFcfFdqHyOzjd {
  background-color: #D62828;
  color: white;
}
.EVSZR28XFcfFdqHyOzjd:hover {
  color: white;
  border-color: #FCBF49;
}

.pGyg0yHuEcsTqd9t9CIb {
  background-color: darkorange;
  color: white;
}

.sf4BtrAbEBoNpXPvVNAA {
  flex-grow: 1;
}

.L_ifS47kwag5khHWhZqf {
  overflow-y: auto;
  display: flex;
  overflow-x: clip;
  flex-direction: column;
}

.LbwcxZj84kpOFGXS90pE {
  width: 30%;
}

.EQJcR5iJVnJNJH81MfCd {
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.lizELxIiHc4z_IfqOfVj {
  font-family: "Chakra Petch";
  font-size: 20px;
  font-weight: 500;
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  flex-direction: column;
}

.VyrPatsowNNhpH9alKdY {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 32px;
}

._0HTmoBTGOTgchP6RPQO {
  min-width: 150px;
}

.gzwaEf0Y2XvqruuzhNMz {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
}

.wOl1EzSo70mRQCqm11v5 {
  font-family: "Chakra Petch";
  font-size: 16px;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/screens/RaffleEdit/RaffleCreateOrEdit.module.scss"],"names":[],"mappings":"AACA;EACI,WAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,gCAAA;AAAJ;;AAGA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,+BAAA;AAAJ;;AAGA;EACI,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,gBAAA;AAAJ;;AAGA;EAEI,mBAAA;AADJ;;AAIA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AADJ;;AAIA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;EACA,iBAAA;EACA,gCAAA;AADJ;;AAIA;EAEI,cAAA;AAFJ;;AAMA;EACI,aAAA;EACA,sFAAA;EACA,gBAAA;AAHJ;;AAMA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AAHJ;;AAOA;EACI,YAAA;AAJJ;;AAOA;EACI,iBAAA;EACA,WAAA;AAJJ;;AAOA;EACI,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,2BAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,oBAAA;AAJJ;;AAOA;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;AAJJ;;AAOA;EACI,yBAAA;EACA,YAAA;AAJJ;AAKI;EACI,YAAA;EACA,qBAAA;AAHR;;AAOA;EACI,4BAAA;EACA,YAAA;AAJJ;;AAOA;EACI,YAAA;AAJJ;;AAOA;EACI,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;AAJJ;;AAOA;EACI,UAAA;AAJJ;;AAOA;EACI,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAJJ;;AAOA;EACI,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AAJJ;;AAOA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AAJJ;;AAOA;EACI,gBAAA;AAJJ;;AAOA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AAJJ;;AAOA;EACI,2BAAA;EACA,eAAA;EACA,gBAAA;AAJJ","sourcesContent":["\r\n.raffleAdminContainer {\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: white;\r\n    padding: 16px;\r\n    border-radius: 8px;\r\n    justify-content: space-between;\r\n    display: flex;\r\n    flex-direction: column;\r\n    row-gap: 16px;\r\n    border-bottom: 1px solid #c4c4c4;\r\n}\r\n\r\n.editRaffleContainer {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow-y: auto;\r\n    max-height: calc(100vh - 18rem);\r\n}\r\n\r\n.editRow {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-evenly;\r\n    column-gap: 32px;\r\n}\r\n\r\n.valueRow {\r\n    @extend .editRow;\r\n    margin-bottom: 16px;\r\n}\r\n\r\n.raffleHeader {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n\r\n.ongoingRaffleValueContainer {\r\n    display: flex;\r\n    flex-direction: row;\r\n    column-gap: 4px;\r\n    padding-bottom: 4px;\r\n    font-family: \"Chakra Petch\";\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    border-bottom: 1px solid #c4c4c4;\r\n}\r\n\r\n.ongoingRaffleValue {\r\n\r\n    color: #48CAE4;\r\n\r\n}\r\n\r\n.stakerOptions {\r\n    display: grid;\r\n    grid-auto-columns: calc(25% - 32px) calc(25% - 32px) calc(25% - 32px) calc(25% - 32px);\r\n    column-gap: 32px;\r\n}\r\n\r\n.textAreaInputRow {\r\n    display: flex;\r\n    flex-direction: row;\r\n    flex: 2 1;\r\n    column-gap: 32px;\r\n}\r\n\r\n\r\n.checkboxContainer {\r\n    width: 182px;\r\n}\r\n\r\n.editorContainer {\r\n    min-height: 200px;\r\n    width: 100%;\r\n}\r\n\r\n.missingRaffleValuesContainer {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: end;\r\n    font-family: \"Chakra Petch\";\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n    color: #D62828;\r\n    padding-bottom: 16px;\r\n}\r\n\r\n.bottomActionContainer {\r\n    display: flex;\r\n    flex-direction: row;\r\n    column-gap: 16px;\r\n    justify-content: end;\r\n}\r\n\r\n.deleteButton {\r\n    background-color: #D62828;\r\n    color: white;\r\n    &:hover {\r\n        color: white;\r\n        border-color: #FCBF49;\r\n    }\r\n}\r\n\r\n.forceButton {\r\n    background-color: darkorange;\r\n    color: white;\r\n}\r\n\r\n.flexGrower {\r\n    flex-grow: 1;\r\n}\r\n\r\n.idoInputContainer {\r\n    overflow-y: auto;\r\n    display: flex;\r\n    overflow-x: clip;\r\n    flex-direction: column;\r\n}\r\n\r\n.buttonContainer {\r\n    width: 30%;\r\n}\r\n\r\n.deleteIdoModalOverlay {\r\n    background-color: rgba(0, 0, 0, 0.6);\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n    top: 0;\r\n    left: 0;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.deleteIdoModal {\r\n    font-family: \"Chakra Petch\";\r\n    font-size: 20px;\r\n    font-weight: 500;\r\n    background-color: white;\r\n    border-radius: 8px;\r\n    padding: 20px;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.deleteRow {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    margin-top: 32px    ;\r\n}\r\n\r\n.selectInputContainer {\r\n    min-width: 150px;\r\n}\r\n\r\n.tokenModalContainer {\r\n    display: flex;\r\n    flex-direction: column;\r\n    row-gap: 8px;\r\n}\r\n\r\n.raffleTokenText {\r\n    font-family: \"Chakra Petch\";\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"raffleAdminContainer": `g14RrfVdvhA3cldPRa1d`,
	"editRaffleContainer": `zBIBTF1ZWUwZz3HhHfv7`,
	"editRow": `EpuI2pda4rp9qbbZkr4R`,
	"valueRow": `ZABmhpxJkDP9ZPfLxe0v`,
	"raffleHeader": `iOltA2ddn_DELFU5ZoVg`,
	"ongoingRaffleValueContainer": `FKzLf9UVlD3ttUq7UY04`,
	"ongoingRaffleValue": `ntssC0Dow3yHUWkDyvXg`,
	"stakerOptions": `mnpcagNcBbt_uBntNR_1`,
	"textAreaInputRow": `TlWMoVaZDutf0u_bCNAQ`,
	"checkboxContainer": `gzwRw_s3CtfURBNSZcIz`,
	"editorContainer": `Swj3N4c8riS_42i4qb55`,
	"missingRaffleValuesContainer": `qudWP3yZXRN8Cs5P3Lsv`,
	"bottomActionContainer": `W87yG8HBDrMIcluIgJwq`,
	"deleteButton": `EVSZR28XFcfFdqHyOzjd`,
	"forceButton": `pGyg0yHuEcsTqd9t9CIb`,
	"flexGrower": `sf4BtrAbEBoNpXPvVNAA`,
	"idoInputContainer": `L_ifS47kwag5khHWhZqf`,
	"buttonContainer": `LbwcxZj84kpOFGXS90pE`,
	"deleteIdoModalOverlay": `EQJcR5iJVnJNJH81MfCd`,
	"deleteIdoModal": `lizELxIiHc4z_IfqOfVj`,
	"deleteRow": `VyrPatsowNNhpH9alKdY`,
	"selectInputContainer": `_0HTmoBTGOTgchP6RPQO`,
	"tokenModalContainer": `gzwaEf0Y2XvqruuzhNMz`,
	"raffleTokenText": `wOl1EzSo70mRQCqm11v5`
};
export default ___CSS_LOADER_EXPORT___;
